"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewMove = void 0;
var HierarchyTypeUtil_1 = require("../../HierarchyTypeUtil");
var types_1 = require("../../types");
var React = __importStar(require("react"));
/** Exhibits how the collection of nodes will grow when selected nodes are moved into it */
var PreviewMove = /** @class */ (function (_super) {
    __extends(PreviewMove, _super);
    function PreviewMove() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PreviewMove.prototype.render = function () {
        var _this = this;
        var _a = this.props, hierarchy = _a.hierarchy, moveInto = _a.moveInto, renderNode = _a.renderNode;
        var hierarchyHeader = hierarchy.hierarchyHeader, nodes = hierarchy.nodes, hierarchyEditState = hierarchy.hierarchyEditState;
        if (!nodes || !hierarchyHeader) {
            return null;
        }
        var hierarchyUtil = HierarchyTypeUtil_1.HierarchyTypeUtilFactory.getHierarchyTypeUtil(hierarchyHeader.hierarchyType);
        var moving = hierarchyUtil.movingNodes(nodes, hierarchyEditState).map(function (n) { return (__assign(__assign({}, _this.previewNodeMove(n)), { isPreview: true })); });
        var intoCollection = moveInto.map(function (n) { return (__assign(__assign({}, nodes[n]), { isPreview: false })); });
        // Compose a preview (merging the nodes being moved w/ the existing collection)
        var preview = __spreadArray(__spreadArray([], moving, true), intoCollection, true);
        if (moving.length > PreviewMove.SORT_NODES_BEING_MOVED_WHEN_GT) {
            // Sort the preview by display name (alphabetically)
            preview.sort(function (x, y) {
                var _a = [x, y].map(function (nodeVm) { return hierarchyUtil.getNodeDisplayName({ nodeVm: nodeVm, hierarchyEditState: hierarchyEditState }); }), nodeXName = _a[0], nodeYName = _a[1];
                return nodeXName.localeCompare(nodeYName);
            });
        }
        var limitPreviewTo = 20;
        return (React.createElement(React.Fragment, null,
            preview.slice(0, limitPreviewTo).map(function (n) { return renderNode(n, n.isPreview); }),
            preview.length > limitPreviewTo && React.createElement("i", null,
                "Preview only shows the first ",
                limitPreviewTo,
                " results")));
    };
    /** Format the node data to a previewable state */
    PreviewMove.prototype.previewNodeMove = function (node) {
        var hierarchyEditState = this.props.hierarchy.hierarchyEditState;
        var previewNodeId = "preview_".concat(node.nodeId);
        return __assign(__assign(__assign({}, node), { nodeId: previewNodeId, editState: undefined, isExpanded: false, nodeData: __assign(__assign({}, node.nodeData), { nodeId: previewNodeId }) }), ((hierarchyEditState === null || hierarchyEditState === void 0 ? void 0 : hierarchyEditState.nodeMoveState) === types_1.NodeMoveState.MoveKeepOpen && {
            name: '',
            childrenIds: [],
            totalRollups: 0,
            totalOpen: 0,
        }));
    };
    /** Defines the threshold at which nodes being moved should be sorted alongside the current set of existing nodes.
     *
     * By default, nodes being moved are displayed first (up top)
     */
    PreviewMove.SORT_NODES_BEING_MOVED_WHEN_GT = 1;
    return PreviewMove;
}(React.PureComponent));
exports.PreviewMove = PreviewMove;
